<template>
    <div class="flex" >
        <video ref="localVideo" autoplay muted v-if="info.type=='local-video'"></video>
        <video ref="remoteVideo" autoplay v-else></video>
        <ul class="flex">
            <li class="ml10">
                <el-button type="primary" size="mini" v-if="!info.bigScreen" @click="$emit('big',info)">切换</el-button>
            </li>
            <li class="">
<!--                <el-button type="success" size="mini"  @click="fullscreen">全屏</el-button>-->
            </li>
        </ul>
    </div>
</template>

<script>
    import {tee3getSelfUser,tee3getRoom,tee3OpenScreenAndPub} from "../../lib/video/tee3"
    import {isEmpty} from "../../lib/utils"
    export default {
        name: "full-video-page",
        props: {
            info: {
                type: Object,
                default() {
                    return Object.create(null)
                }
            },
            pulished:{
                type: Boolean,
                default:true
            },
        },
        data(){
            return {

            }
        },
        mounted(){
            this.init();
        },
        watch:{
            info(){
                this.init();
            }
        },
        methods:{
            init() {
                const {type, stream, screenFlag,screenStream} = this.info;
                if (type === 'local-video') {
                    if(screenFlag){
                      this.$refs.localVideo.srcObject = screenStream;
                    }else{
                      this.$refs.localVideo.srcObject = stream;
                    }
                } else if (type === 'video') {
                    if(screenFlag){
                        this.$refs.remoteVideo.srcObject = screenStream;
                        console.log(screenStream)
                    }else{
                        this.$refs.remoteVideo.srcObject = stream;
                        console.log(stream)
                    }
                }
            },
            fullscreen() {
                const ele = this.$refs.remoteVideo;
                if (ele.requestFullscreen) {
                    ele.requestFullscreen();
                } else if (ele.mozRequestFullScreen) {
                    ele.mozRequestFullScreen();
                } else if (ele.webkitRequestFullScreen) {
                    ele.webkitRequestFullScreen();
                }
            },
            screenClick(){
                bus.$emit('shareScreen',this.$refs['remoteVideo']);
            },
        }
    }
</script>

<style scoped>
    video {
        width: 100%;
    }

    ul {
        flex-direction: row-reverse;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
    }
</style>
